"use strict";
(self["webpackChunklittle_sleepies"] = self["webpackChunklittle_sleepies"] || []).push([[3393,3524,9401],{

/***/ 3393:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Drawer)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _swiper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3524);
// components/drawer.js



function Drawer({ wrapper }) {
  const selectors = {
    drawerTrigger: '.js-drawer-trigger',
    drawerClose: '.js-drawer-close',
    drawer: '.js-drawer',
    overlay: '.js-drawer-overlay',
    productForm: 'form[action="/cart/add"]',
  }

  const drawerId = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.drawer).attr('id')

  const cache = {
    $drawerTrigger: jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).find(selectors.drawerTrigger).filter(`[data-drawer="${drawerId}"]`),
    $drawerClose: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.drawerClose),
    $drawer: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.drawer),
    $overlay: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.overlay),
    $productForm: jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find(selectors.productForm),
  }

  ;(function init() {
    const { $drawerTrigger, $drawer } = cache

    if (!$drawerTrigger.length) return

    initializeEventListeners()
  })()

  function initializeEventListeners() {
    const { $drawerTrigger, $drawerClose, $productForm } = cache

    $drawerTrigger.on('click', toggleDrawer)
    $drawerClose.on('click', closeDrawer)
    $productForm.on('submit', closeDrawer)
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('keydown', listenForEscape)
    
      // Close drawer when clicking on navigation elements (the drawer trigger handles its own toggle)
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(document).on('click', 'nav button, .js-sub-nav button, a[href="/cart"]', function(e) {
        if (!jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).hasClass('js-drawer-trigger')) {
          closeDrawer(e)
        }
      })
  
  }

  function toggleDrawer(e) {
    const { $drawer } = cache
    // If drawer is already open (has 'active' class), close it; otherwise open it
    if ($drawer.hasClass('active')) {
      closeDrawer(e)
    } else {
      openDrawer.call(this, e)
    }
  }

  function listenForEscape(e) {
    if (e.keyCode === 27) {
      closeDrawer(e)
    }
  }

  function openDrawer(e) {
    e.preventDefault()
    const { $drawer, $overlay } = cache

    let $this = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)
    let targetDrawer = $this.data('drawer')
    
    // If opening the notification drawer, ensure any open mega menu is closed first
    if (targetDrawer === 'notification-drawer') {
      const $mobileToggle = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-open-mobile-menu]')
      const $desktopToggle = jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-open-desktop-menu]')
      if ($mobileToggle.hasClass('on')) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-close-mobile-menu]').trigger('click')
      }
      if ($desktopToggle.hasClass('on')) {
        jquery__WEBPACK_IMPORTED_MODULE_0___default()('[data-close-desktop-menu]').trigger('click')
      }
    }
    
    if ($drawer.data('drawer') == targetDrawer) {
      $this.addClass('active')
      $drawer.show()

      setTimeout(function () {
        $drawer.addClass('active')
        $overlay.fadeIn(150)

        // Initialize sliders inside the drawer content with a small delay to ensure rendering
        setTimeout(function () {
          const sliders = $drawer.find('[data-slick]')

          sliders.each(function () {
            const $slider = jquery__WEBPACK_IMPORTED_MODULE_0___default()(this)

            // If slick is already initialized, refresh it
            if ($slider.hasClass('slick-initialized')) {
              $slider.slick('refresh')
              $slider.slick('slickGoTo', 0, false)
            } else {
              // Otherwise initialize it
              new _swiper_js__WEBPACK_IMPORTED_MODULE_1__["default"](this).init()
            }
          })
        }, 50)
      }, 10)

      jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').addClass('no-scroll')
    }
  }

  function closeDrawer(e) {
    e.preventDefault()
    const { $drawerTrigger, $drawer, $overlay } = cache

    $drawerTrigger.removeClass('active')
    $drawer.removeClass('active')
    $overlay.fadeOut(150)

    setTimeout(function () {
      $drawer.hide()
    }, 400)

    jquery__WEBPACK_IMPORTED_MODULE_0___default()('body').removeClass('no-scroll')
  }
}


/***/ }),

/***/ 3524:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Slider)
/* harmony export */ });
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4692);
/* harmony import */ var jquery__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(jquery__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swiper_bundle__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1732);
/* harmony import */ var _on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4797);
/* harmony import */ var _utilities_swiper_accessibility__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9401);





function Slider({ wrapper }) {
  const { classes } = window.config

  const defaultSettings = {
    centeredSlidesBounds: true,
    cssMode: true,
    slidesPerView: 'auto',
    breakpoints: {
      768: {
        centeredSlidesBounds: true,
        cssMode: false,
        grabCursor: true,
      },
    },
  }

  let settings = null
  let swiper = null

  ;(function init() {
    buildSettings()

    swiper = new swiper_bundle__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .A(wrapper, settings)

    // Add active class to button if autoplay is enabled by default
    if (swiper.autoplay && swiper.autoplay.running) {
      const $toggleButton = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('[data-action="toggle-autoplay"]')
      if ($toggleButton.length > 0) {
        $toggleButton.addClass('on')
      }
    }

    initEventListeners()
    
    // Add accessibility using the utility
    ;(0,_utilities_swiper_accessibility__WEBPACK_IMPORTED_MODULE_3__.addSwiperAccessibility)(swiper)
  })()

  function buildSettings() {
    // Use the default config if one isn't provided
    settings = jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('swiper') ? jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).data('swiper') : defaultSettings
    // Set "cssMode" to "auto" by default
    if ((!settings.cssMode && settings.cssMode !== false) || settings.cssMode == 'auto') {
      settings.cssMode = (0,_on_sight_dev_tools_utils__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .A)()
    }
  }

  function initEventListeners() {
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('swiper:requestInstance', function () {
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).trigger('swiper:receiveInstance', [swiper])
    })

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('.swiper-wrapper').removeAttr('aria-live')

    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).find('.swiper-button-next, .swiper-button-prev').removeAttr('aria-controls')
    // Add toggle playback functionality
    jquery__WEBPACK_IMPORTED_MODULE_0___default()(wrapper).on('click', '[data-action="toggle-autoplay"]', togglePlayback)

    // Accessibility is now handled by addSwiperAccessibility utility
  }


  function togglePlayback(e) {
    e.preventDefault()

    // Check if autoplay is currently running
    const isAutoplayRunning = swiper.autoplay && swiper.autoplay.running

    if (isAutoplayRunning) {
      swiper.autoplay.stop()
      // Remove on class from button to show play icon
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).removeClass('on')
    } else {
      swiper.autoplay.start()
      // Add on class to button to show pause icon
      jquery__WEBPACK_IMPORTED_MODULE_0___default()(this).addClass('on')
    }
  }

  return swiper
}


/***/ }),

/***/ 4797:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: () => (/* binding */ isMobile)
/* harmony export */ });
/**
 * * Determines if the current screen is mobile-sized
 *
 * @returns {boolean} Whether the current screen width is within the mobile threshhold
 */
function isMobile() {
  if (
    /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
      navigator.userAgent
    ) ||
    /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
      navigator.userAgent.substr(0, 4)
    )
  ) {
    return true
  }

  return false
}

/***/ }),

/***/ 9401:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   addSwiperAccessibility: () => (/* binding */ addSwiperAccessibility)
/* harmony export */ });
// utility to add accessibility attributes to swiper slides
function addSwiperAccessibility(swiper) {
  const container = swiper.el
  let intersectionObserver = null
  
  // Function to update slide accessibility
  function updateSlideAccessibility() {
    const slides = container.querySelectorAll('.swiper-slide')
    
    // Stop observing all slides first
    slides.forEach((slide) => {
      if (intersectionObserver) {
        intersectionObserver.unobserve(slide)
      }
    })

    // Start observing all slides
    slides.forEach((slide) => {
      if (intersectionObserver) {
        intersectionObserver.observe(slide)
      }
    })

  }
  
  // Create intersection observer to track slide visibility
  intersectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const slide = entry.target
        const isVisible = entry.isIntersecting

        if (isVisible) {
          // Slide is visible - remove aria-hidden and tabindex, restore inner elements
          slide.removeAttribute('aria-hidden')
          slide.removeAttribute('tabindex')
          restoreTabbableElements(slide)
        } else {
          // Slide is not visible - add aria-hidden and tabindex="-1", disable inner elements
          slide.setAttribute('aria-hidden', 'true')
          slide.setAttribute('tabindex', '-1')
          disableTabbableElements(slide)
        }
      })
    },
    {
      root: container,
      rootMargin: '0px',
      threshold: 0.1, // Trigger when 10% of the slide is visible
    }
  )
  
  // Function to disable tabbable elements in hidden slides
  function disableTabbableElements(slide) {
    const tabbableElements = slide.querySelectorAll(
      'button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
    
    tabbableElements.forEach((element) => {
      if (element.hasAttribute('tabindex')) {
        element.setAttribute('data-original-tabindex', element.getAttribute('tabindex'))
      }
      element.setAttribute('tabindex', '-1')
    })
  }
  
  // Function to restore tabbable elements in visible slides
  function restoreTabbableElements(slide) {
    if (slide.getAttribute('aria-hidden') === 'true') {
      return
    }
    
    const tabbableElements = slide.querySelectorAll('[tabindex="-1"]')
    
    tabbableElements.forEach((element) => {
      if (element.hasAttribute('data-original-tabindex')) {
        const originalTabindex = element.getAttribute('data-original-tabindex')
        if (originalTabindex !== '-1') {
          element.setAttribute('tabindex', originalTabindex)
        } else {
          element.removeAttribute('tabindex')
        }
        element.removeAttribute('data-original-tabindex')
      } else {
        element.removeAttribute('tabindex')
      }
    })
  }
  
  setTimeout(() => {
    updateSlideAccessibility()
  }, 100)
  
  // Update on slide change
  swiper.on('activeIndexChange', function () {
    updateSlideAccessibility()
  })
}


/***/ })

}]);